export enum CABIN_STATUS {
    undefined,
    no_area,
    engage,
    setup,
    searching,
    mine_is_set,
    stats,
}
